<div class="statsItem">
    <div class="statsItem-infos">
        <span class="statsItem-infos-label">
            <ng-content select="[statLabel]"></ng-content>
        </span>
        <span class="statsItem-infos-mention">
            <ng-content select="[statMention]"></ng-content>
        </span>
    </div>

    <div class="statsItem-stats">
        <span class="statsItem-stats-value">
            <ng-content select="[statValue]"></ng-content>
        </span>
    </div>
</div>
